// hooks/email/useRetornoEmail.ts

import useApiErrorHandler from '../useApiErrorHandler';
import useLoading from '../useLoading';

import FiscalEventService from '../../services/fiscal/FiscalEventService';
import useModals from '../useModals';

export const useRetornoEmail = () => {
    const { openModal } = useModals();

    const { handle } = useApiErrorHandler();
    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    const sendRetornoEmail = async (
        fiscalEventId: number
    ) => {
        try {
            showLoadingIndicator();

            const response =
                await FiscalEventService.sendEmail(
                    fiscalEventId
                );

            openModal(
                response.type,
                { title: response.title, message: response.message }
            );

            return true;

        } catch (error) {

            handle(error);

            return false;

        } finally {

            hideLoadingIndicator();

        }
    };

    return {
        sendRetornoEmail,
    };
};

export default useRetornoEmail;
